/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import { Injectable, Inject } from '@angular/core';
import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");

export function initialize(module: ng.IModule) {
    module.service(RoleDataService.Id, RoleDataService);

    RoleDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

@Injectable()
export class RoleDataService extends base.BaseDataService<Nema.Crew.Model.Role> implements IRoleDataService {

    constructor(
        @Inject("entityManagerService") entityManagerService: service.EntityManagerService,
        @Inject("breeze") breeze,
        @Inject("$log") $log,
        @Inject("$q") $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id = "roleDataService";

    public get EntityName(): string {
        return "Role";
    }

    public get EntitiesName(): string {
        return "Roles";
    }
}

export interface IRoleDataService extends base.IDataService<Nema.Crew.Model.Role> {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/roles.dataservice.ts